import { useImagePreviewState } from "../../image-preview-context";
import { Text } from "../../../text";

/**
 * Tool for the ImagePreview toolbox. Shows the current image index and the total number of images.
 */
export const Counts = () => {
    const { images, currentIndex } = useImagePreviewState();
    if (images.length <= 1) return null;
    return (
        <Text size="xs" variant="semibold" c="white">
            {`${currentIndex + 1} / ${images.length}`}
        </Text>
    );
};
